import { Typography } from 'antd';
import { type ReactNode } from 'react';
import AuthorizedComponent from './authorized-component';
import { Roles } from '../types';

const DetailedSite = ({ site, showCounty = true, ...rest }: any): ReactNode => {
  // For HHC Admins
  const displaySiteNumber = site.displaySiteNumber ? `(${site.displaySiteNumber})` : '';
  const siteCounty = site.county && showCounty ? `(${site.county})` : '';

  // For Customer Admins and Customer Standard Users
  const siteCustSiteNumber = site.custSiteNumber ? `- ${site.custSiteNumber}` : '';
  const customerSiteCounty = site.county && showCounty ? `- ${site.county}` : '';
  return (
    <>
      <AuthorizedComponent roles={[Roles.ROLE_HHC_ADMIN]}>
        <Typography.Text
          {...rest}
        >{`${site.name} ${displaySiteNumber} ${siteCounty}`}</Typography.Text>
      </AuthorizedComponent>
      <AuthorizedComponent roles={[Roles.ROLE_CUSTOMER_ADMIN, Roles.ROLE_CUSTOMER_STANDARD]}>
        <Typography.Text
          {...rest}
        >{`${site.name} ${siteCustSiteNumber} ${customerSiteCounty}`}</Typography.Text>
      </AuthorizedComponent>
    </>
  );
};

export default DetailedSite;
